module.exports = __webpack_public_path__ + "img/vintage.df87c47.jpg";